import React from 'react';
import classNames from 'classnames';

const SidebarSettingsList = ({ className, ...props }) => (
	<ul className={classNames("sidebar-settings-list", className)} {...props} />
);

export default SidebarSettingsList;
